import Link from 'next/link'
import React from 'react'

import { useProduct } from '@/screens/Product/hooks/useProduct'
import { GarantyIcon } from '@/screens/Product/page/assets/GarantyIcon'
import { LikeIcon } from '@/screens/Product/page/assets/LikeIcon'
import { OriginalIcon } from '@/screens/Product/page/assets/OriginalIcon'
import { ToolIcon } from '@/screens/Product/page/assets/ToolIcon'

import cl from './product-triggers.module.scss'

export const ProductTriggers = (): JSX.Element => {
	const { product } = useProduct()

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	const period = product.WARRANTY_PERIOD === 24 ? `2 года гарантии` : `Официальная гарантия `
	return (
		<Link prefetch={false} href="/space" target="_blank">
			<ul className={cl.list}>
				<li className={cl.item}>
					<OriginalIcon />
					<p>Оригинальная техника</p>
				</li>
				<li className={cl.item}>
					<GarantyIcon />
					<p>{period}</p>
				</li>
				<li className={cl.item}>
					<ToolIcon />
					<p>Поддержка экспертов </p>
				</li>
				<li className={cl.item}>
					<LikeIcon />
					<p>Оплата бонусами до 99%</p>
				</li>
			</ul>
		</Link>
	)
}
